import React from 'react';
import { FORMATTING_BUTTONS, insertLinkAtCurrentSelection, getEntityData, insertCustomLink, hasLinksInSelection, COMMANDS, MODIFIERS, removeLinksInSelection, LinkIcon, BUTTON_TYPES, getModalStyles, EditorModals, isAtomicBlockInSelection } from 'wix-rich-content-editor-common';
import createInlineButtons from './inline-buttons.js';
import TextLinkButton from './TextLinkButton.js';
import { LINK_TYPE } from '../types.js';
import 'wix-rich-content-plugin-commons';
import './RemoveLinkButton.js';
import 'prop-types';
import '../icons/RemoveLinkIcon.js';
import './UrlLinkButton.js';
import 'classnames';
import '../link-viewer-54ef808f.js';
import 'wix-rich-content-common';
import 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const openLinkModal = ({
  helpers,
  isMobile,
  anchorTarget,
  relValue,
  t,
  theme,
  getEditorState,
  setEditorState,
  uiSettings,
  closeInlinePluginToolbar,
  settings
}) => {
  const modalStyles = getModalStyles({
    fullScreen: isMobile,
    isMobile,
    customStyles: isMobile ? { content: { position: "fixed" } } : { content: { maxWidth: "max-content", padding: 20 } }
  });
  if (helpers && helpers.openModal) {
    const modalProps = {
      helpers,
      modalStyles,
      isMobile,
      getEditorState,
      setEditorState,
      t,
      theme,
      anchorTarget,
      relValue,
      modalName: EditorModals.TEXT_LINK_MODAL,
      hidePopup: helpers.closeModal,
      uiSettings,
      insertLinkFn: insertLinkAtCurrentSelection,
      closeInlinePluginToolbar,
      linkTypes: settings == null ? void 0 : settings.linkTypes
    };
    helpers.openModal(modalProps);
  } else {
    console.error(
      "Link plugin: failed to display Link modal dialog since helpers.openModal is not defined"
    );
  }
};
const createToolbar = (config) => {
  var _a, _b;
  const isDisabled = () => isAtomicBlockInSelection(config.getEditorState());
  const getTooltip = () => config.t(
    isDisabled() ? "TextLinkButton_DisableButtonForPlugins_Tooltip" : "TextLinkButton_Tooltip"
  );
  return __spreadProps(__spreadValues({
    TextButtonMapper: () => ({
      [FORMATTING_BUTTONS.LINK]: {
        component: (props) => /* @__PURE__ */ React.createElement(
          TextLinkButton,
          __spreadValues({
            insertLinkFn: insertLinkAtCurrentSelection,
            getEntityData,
            insertCustomLink,
            isActive: hasLinksInSelection(config.getEditorState()),
            closeInlinePluginToolbar: config.closeInlinePluginToolbar,
            tooltipText: getTooltip(),
            innerModal: config.innerModal,
            disabled: isDisabled()
          }, props)
        ),
        keyBindings: [
          {
            keyCommand: {
              command: COMMANDS.LINK,
              modifiers: [MODIFIERS.COMMAND],
              key: "k"
            },
            commandHandler: (editorState) => {
              config.onKeyboardShortcutClick({ buttonName: COMMANDS.LINK, pluginId: LINK_TYPE });
              if (hasLinksInSelection(editorState)) {
                config.closeInlinePluginToolbar();
                return removeLinksInSelection(editorState);
              } else if (!isDisabled()) {
                openLinkModal(config);
              }
            }
          }
        ],
        externalizedButtonProps: {
          onClick: (e) => {
            e.preventDefault();
            openLinkModal(config);
          },
          isActive: () => hasLinksInSelection(config.getEditorState()),
          isDisabled,
          getIcon: () => {
            var _a2, _b2, _c;
            return ((_c = (_b2 = (_a2 = config[LINK_TYPE]) == null ? void 0 : _a2.toolbar) == null ? void 0 : _b2.icons) == null ? void 0 : _c.InsertPluginButtonIcon) || (() => {
              var _a3, _b3;
              return LinkIcon({
                newFormattingToolbar: (_b3 = (_a3 = config == null ? void 0 : config.experiments) == null ? void 0 : _a3.newFormattingToolbar) == null ? void 0 : _b3.enabled
              });
            });
          },
          tooltip: getTooltip(),
          getLabel: () => "",
          // new key needed?
          type: BUTTON_TYPES.BUTTON
        }
      }
    })
  }, ((_b = (_a = config[LINK_TYPE]) == null ? void 0 : _a.toolbar) == null ? void 0 : _b.inlineToolbar) === false ? {} : { InlinePluginToolbarButtons: createInlineButtons(config) }), {
    name: "link"
  });
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
